import React, { useEffect } from 'react';
import { List, Datagrid, TextField, FunctionField } from 'react-admin';

function NuestraHistoriaList(props: any) {
  useEffect(() => {
    document.title = 'Nuestra Historia - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="anoImage" label="Año" />
        <TextField source="tituloImage" label="Hito" />
        <FunctionField
          label="Imagen"
          render={(record: any) => (
            record.image ? (
              <img
                src={record.image.url}
                alt="Hito histórico"
                style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
              />
            ) : null
          )}
        />
      </Datagrid>
    </List>
  );
}

export default NuestraHistoriaList;